import React, { PureComponent } from "react";

import { InputWrapper, Input } from '../components/ui';

class InputPercentage extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      newValue: 0,
    };
  }

  handleInputChange = event => {
    const { onInputChange } = this.props;

    const { name, value } = event.target;

    this.setState({
      newValue: value,
    },
      () => {
        onInputChange(name, value)
      }
    );
  };

  render() {

    const {
      name,
      value,
      disabled = false
    } = this.props;

    const { newValue } = this.state;

    const displayValue = newValue ? newValue : value;

    return (
      <InputWrapper>
        <Input
          type="number"
          value={displayValue}
          onChange={this.handleInputChange}
          name={name}
          disabled={disabled}
        />
      </InputWrapper>
    );
  }
}

export default InputPercentage;



// WEBPACK FOOTER //
// ./src/instructor/components/grading/components/input-percentage.js